import React, { useState, useEffect } from 'react'
import ListItems from './ListItems';


export default function PriceTracker() {

    const [datas, setData] = useState([]);

    let myData = []



    let fetchFunction = async () => {

        let url = "https://cors-anywhere.herokuapp.com/https://api.nomics.com/v1/currencies/ticker?key=6a4ae5413084bd7c90df6669d115e7ad3c94644e";
        let data = await fetch(url);
        setData(await data.json());
        console.log(datas);
 
    };

 
    useEffect( ()=>{

        fetchFunction();

        setInterval(fetchFunction,30000);
        // setTimeout(()=>{setData(myData)},3000);

    },[])
  

     

    let myStyle = {
        backgroundColor: '#03001e'
    }

    return (

        <div style={myStyle}>
          

          <p className='text-center text-white text-xl'>Latest Crypto prices (updates every 30 sec)</p>


            <div id="change" className="container mx-auto h-screen  rounded-xl overflow-scroll">

              

                <ul  className='list-none '>

                    {datas.map((element)=>{
                        return <ListItems key={element.id} name={element.name} price={element.price}/>
                    })}

                </ul>

            </div>
        </div>
    )
}
